import React from "react";
import "./LuxuryCab.css";
import { Link } from "react-router-dom";
import BMWLuxuryCab from "../../assets/BMWLuxuryCab.png";
import AudiPremiumCab from "../../assets/AudiPremiumCab.png"
import MercedesEliteCab from "../../assets/MercedesEliteCab.png"
import JaguarLuxuryRide from "../../assets/JaguarLuxuryRide.png"
import LexusComfortCab from "../../assets/LexusComfortCab.png"
import BMWExecutiveCab from "../../assets/BMWExecutiveCab.png"
import AudiCityLuxury from "../../assets/AudiCityLuxury.png"
import MercedesPrimeCab from "../../assets/MercedesPrimeCab.png"
import JaguarRoyalRide from "../../assets/JaguarRoyalRide.png"
import LexusEliteCab from "../../assets/LexusEliteCab.png"
import BMWUrbanLuxury from "../../assets/BMWUrbanLuxury.png"
import AudiExecutiveRide from "../../assets/AudiExecutiveRide.png"
import MercedesComfortCab from "../../assets/MercedesComfortCab.png"
import JaguarExecutiveRide from "../../assets/JaguarExecutiveRide.png"
import LexusPremiumCab from "../../assets/LexusPremiumCab.png"
import BMWRoyalCab from "../../assets/BMWRoyalCab.png"
import AudiPrestigeCab from "../../assets/AudiPrestigeCab.png"
import MercedesRoyalRide from "../../assets/MercedesRoyalRide.png"
import JaguarPrestigeCab from "../../assets/JaguarPrestigeCab.png"
import LexusGrandCab from "../../assets/LexusGrandCab.png";
const luxuryCabData = [
  {
    id: 1,
    name: "BMW Luxury Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1400,
    image: BMWLuxuryCab,
  },
  {
    id: 2,
    name: "Audi Premium Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1420,
    image: AudiPremiumCab,
  },
  {
    id: 3,
    name: "Mercedes Elite Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1450,
    image: MercedesEliteCab,
  },
  {
    id: 4,
    name: "Jaguar Luxury Ride",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1480,
    image: JaguarLuxuryRide,
  },
  {
    id: 5,
    name: "Lexus Comfort Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1430,
    image: LexusComfortCab,
  },
  {
    id: 6,
    name: "BMW Executive Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1460,
    image: BMWExecutiveCab,
  },
  {
    id: 7,
    name: "Audi City Luxury",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1410,
    image: AudiCityLuxury,
  },
  {
    id: 8,
    name: "Mercedes Prime Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1470,
    image: MercedesPrimeCab,
  },
  {
    id: 9,
    name: "Jaguar Royal Ride",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1500,
    image: JaguarRoyalRide,
  },
  {
    id: 10,
    name: "Lexus Elite Cab",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1440,
    image: LexusEliteCab,
  },
  {
    id: 11,
    name: "BMW Urban Luxury",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1420,
    image: BMWUrbanLuxury,
  },
  {
    id: 12,
    name: "Audi Executive Ride",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1460,
    image: AudiExecutiveRide,
  },
  {
    id: 13,
    name: "Mercedes Comfort Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1430,
    image: MercedesComfortCab,
  },
  {
    id: 14,
    name: "Jaguar Executive Ride",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1470,
    image: JaguarExecutiveRide,
  },
  {
    id: 15,
    name: "Lexus Premium Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1450,
    image: LexusPremiumCab,
  },
  {
    id: 16,
    name: "BMW Royal Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1480,
    image: BMWRoyalCab,
  },
  {
    id: 17,
    name: "Audi Prestige Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1500,
    image: AudiPrestigeCab,
  },
  {
    id: 18,
    name: "Mercedes Royal Ride",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1520,
    image: MercedesRoyalRide,
  },
  {
    id: 19,
    name: "Jaguar Prestige Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1510,
    image: JaguarPrestigeCab,
  },
  {
    id: 20,
    name: "Lexus Grand Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1530,
    image: LexusGrandCab,
  },
];

const LuxuryCab = () => {
  return (
    <div className="luxury-cab-container">
      {luxuryCabData.map((cab) => (
        <Link
          to="/adventure-traveller-detail-page"
          className="luxury-cab-link"
          state={{
            carData: cab,
            totalPrice: cab.price, // ✅ sending price
          }}
          key={cab.id}
        >
          {" "}
          <div className="luxury-cab-card" key={cab.id}>
            <div className="luxury-fuel-tag">{cab.fuel}</div>

            <div className="luxury-price-tag"> ₹{cab.price}</div>
            <div className="luxury-image-div">
              <img
                src={cab.image}
                alt={cab.name}
                className="luxury-cab-image"
              />
            </div>
            <div className="luxury-cab-info">
              <h2>{cab.name}</h2>
              <p>{cab.passenger}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default LuxuryCab;
